
const fuseOptions = {
  shouldSort:         true,
  threshold:          0.3,
  location:           0,
  distance:           100,
  maxPatternLength:   72,
  minMatchCharLength: 1,
  ignoreLocation:     true,
  keys:               [
    {
      name:   'customer.name.full',
      weight: 0.1
    },
    {
      name:   'customer.name.given',
      weight: 0.09
    },
    {
      name:   'customer.name.surname',
      weight: 0.08
    },
    {
      name:   'customer.contact.email.address',
      weight: 0.07
    },
    {
      name:   'customer.contact.phone.text',
      weight: 0.07
    },
    {
      name:   'customer.status',
      weight: 0.06
    },
    {
      name:   'note.body',
      weight: 0.06
    },
    {
      name:   'lastActivity.text',
      weight: 0.05
    },
    {
      name:   'assignees.user.name',
      weight: 0.05
    }
  ]
};

export default fuseOptions;
